/**
 * @generated SignedSource<<e4f1a7e4b99c9f7e13d2b6a015be3cd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TeamHeaderLeaveTeamMutation$variables = {
  id: string;
};
export type TeamHeaderLeaveTeamMutation$data = {
  readonly leaveTeam: {
    readonly team: {
      readonly archived: boolean;
      readonly description: string | null;
      readonly handle: string | null;
      readonly hasAccess: boolean;
      readonly id: string;
      readonly location: string | null;
      readonly members: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly parent: {
        readonly id: string;
      } | null;
      readonly title: string;
    };
  } | null;
};
export type TeamHeaderLeaveTeamMutation = {
  response: TeamHeaderLeaveTeamMutation$data;
  variables: TeamHeaderLeaveTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "LeaveTeamMutation",
    "kind": "LinkedField",
    "name": "leaveTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "parent",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "handle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccess",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamHeaderLeaveTeamMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamHeaderLeaveTeamMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "567aeb68815f0e058310ea31f42b262f",
    "id": null,
    "metadata": {},
    "name": "TeamHeaderLeaveTeamMutation",
    "operationKind": "mutation",
    "text": "mutation TeamHeaderLeaveTeamMutation(\n  $id: ID!\n) {\n  leaveTeam(id: $id) {\n    team {\n      id\n      title\n      description\n      members {\n        id\n      }\n      parent {\n        id\n      }\n      handle\n      location\n      archived\n      hasAccess\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c2417020f7ef5722a87cf89f7d53189";

export default node;
